import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LayoutsModule } from './components/_layouts/layouts.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { HttpResponseInterceptor } from './core/interceptors/http-response.interceptor';
import { LogoutComponent } from './components/logout/logout.component';
import { LandingVideoComponent } from './modules/widgets/landing-video/landing-video.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { IncomingCallComponent } from './modules/widgets/incoming-call/incoming-call.component';
import { OutgoingCallComponent } from './modules/widgets/outgoing-call/outgoing-call.component';
import { ActiveCallComponent } from './components/active-call/active-call.component';
import { CallBubbleComponent } from './components/call-bubble/call-bubble.component';

const config: SocketIoConfig = {
  url: environment.webUrl,
  options: { autoConnect: true },
};

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LogoutComponent,
    LandingVideoComponent,
    IncomingCallComponent,
    OutgoingCallComponent,
    ActiveCallComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutsModule,
    ReactiveFormsModule,
    SocketIoModule.forRoot(config),
    CallBubbleComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpResponseInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
